import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import { getBookmarkJobs } from "../../actions/bookmarkJob";
import {
  bookmarkJob as bookmarkJobApi,
  removeBookmarkJob,
} from "../../api/bookmarkJob";
import { apiErrorHandler } from "../common";
import { CustomSnackbar } from "../CustomSnackbar";

const AddToBookmarkJob = ({ size, companyDetails, jobDetails, onRemoved }) => {
  const customer = useSelector((state) => state.customer.profile);
  const bookmarkJobs = useSelector((state) => state.bookmarkJob.data);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClick = (type, item) => {
    setLoading(true);
    if (type === 1) {
      // Add to bookmark job API
      bookmarkJobApi({ jobid: jobDetails?.id })
        .then((res) => {
          if (res?.data) {
            CustomSnackbar.success("Added to bookmarks");
            dispatch(getBookmarkJobs());
          }
        })
        .catch((err) => {
          apiErrorHandler(err);
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    } else {
  // 1. Pehle confirm karein ki humare paas Bookmark ki ID hai
  // 'item' wahi hai jo 'findBookmarkedJob' se mila tha
  const bookmarkEntryId = item?.id; 

  if (!bookmarkEntryId) {
    CustomSnackbar.error("Bookmark ID not found.");
    setLoading(false);
    return;
  }

  // Remove from bookmark job API
  removeBookmarkJob(bookmarkEntryId)
    .then((res) => {
      // API response check: Kuch backend 'success' key bhejte hain, kuch nahi
      if (res?.success || res) { 
        // ✅ Sabse important: State refresh karo
        dispatch(getBookmarkJobs(customer?.id));
        CustomSnackbar.success("Removed successfully.");
        // ✅ Bookmark list wale card ko turant hide karo
        if (onRemoved) {
          onRemoved();
        }
      }
    })
    .catch((err) => {
      apiErrorHandler(err);
    })
    .finally(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
}
  };

const findBookmarkedJob = Array.isArray(bookmarkJobs)
  ? bookmarkJobs.find((item) => {
      // Case 1: Agar item ke andar job object hai (Aapka current response format)
      const idFromJobObject = item?.job?.id;
      
      // Case 2: Agar item khud hi job entry hai
      // (item.id sirf tab use karo jab item me job object na ho, warna ye
      // bookmark ki apni id hoti hai aur kisi dusre job ki id se match ho sakti hai)
      const idDirect = item?.job ? item?.jobId : (item?.jobId || item?.id);

      // Current job ki ID se match karo
      const currentJobId = jobDetails?.id;

      return (
        Number(idFromJobObject) === Number(currentJobId) || 
        Number(idDirect) === Number(currentJobId)
      );
    })
  : null;

  if (customer?.customer_type === 1) {
    return <></>;
  }

  // Lg component
  if (size === "lg") {
    return loading ? (
      <>
        {/* Showing loading button */}
        {findBookmarkedJob ? (
          <span className='btn btn-soft-danger btn-hover w-100 mt-2 disabled'>
            Remove from Bookmark <Spinner size='sm' />
          </span>
        ) : (
          <span className='btn btn-soft-warning btn-hover w-100 mt-2'>
            Add Bookmark <Spinner size='sm' />
          </span>
        )}
      </>
    ) : !findBookmarkedJob ? (
      <span
        onClick={(e) => {
          e.preventDefault();
          if (!loading) {
            handleClick(1);
          }
        }}
        className='btn btn-soft-warning btn-hover w-100 mt-2'
        title='Bookmark'
      >
        <i className='uil uil-bookmark'></i> Add Bookmark
      </span>
    ) : (
      <span
        onClick={(e) => {
          e.preventDefault();
          handleClick(0, findBookmarkedJob);
        }}
        className='btn btn-soft-danger btn-hover w-100 mt-2'
        title='Unbookmark'
      >
        <i className='uil uil-bookmark'></i> Remove from Bookmark
      </span>
    );
  }

  // Md component
  if (size === "md") {
    return (
      <>
        {loading ? (
          <div className={`bookmark-label text-center bg-primary`}>
            <span className='text-white align-middle'>
              <div
                style={{
                  height: 30,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Spinner size='sm' />
              </div>
            </span>
          </div>
        ) : !findBookmarkedJob ? (
          <div
            className={`bookmark-label text-center cursor-pointer`}
            onClick={(e) => {
              e.preventDefault();
              if (!loading) {
                handleClick(1);
              }
            }}
          >
            <span className="text-white align-middle" title="Bookmark">
              <i className="uil uil-bookmar-alt"></i>
            </span>
          </div>
        ) : (
          <div
            className={`bookmark-label text-center bg-primary`}
            onClick={(e) => {
              e.preventDefault();
              handleClick(0, findBookmarkedJob);
            }}
          >
            <span className="text-white align-middle" title="Unbookmark">
              <i className="uil uil-heart-alt"></i>
            </span>
          </div>
        )}
      </>
    );
  }

  // Sm component
  if (size === "sm") {
    return (
      <>
        {loading ? (
          <div className='favorite-icon'>
            <span className='bg-danger d-flex align-items-center justify-content-center'>
              <Spinner size='sm' color='white'></Spinner>
            </span>
          </div>
        ) : !findBookmarkedJob ? (
          <div
            className='favorite-icon'
            onClick={(e) => {
              e.preventDefault();
              if (!loading) {
                handleClick(1);
              }
            }}
          >
            <span title='Bookmark'>
              <i className='uil uil-heart-alt fs-18'></i>
            </span>
          </div>
        ) : (
          <div
            className='favorite-icon'
            onClick={(e) => {
              e.preventDefault();
              if (!loading) {
                handleClick(0, findBookmarkedJob);
              }
            }}
          >
            <span className='bg-danger' title='Unbookmark'>
              <i className='uil uil-heart-alt fs-18 text-white'></i>
            </span>
          </div>
        )}
      </>
    );
  }

  return <></>;
};

export default AddToBookmarkJob;